module.exports = __webpack_public_path__ + "static/media/viberForForm.d0aa198c.svg";